import { Trans, useTranslation } from 'react-i18next';
import { DeviceCardProps } from '../DeviceCardProps';
import DriveUnitPortControl from '../Controls/DriveUnitPortControl';
import DeviceCardWrapper from '../DeviceCardWrapper';
import { MagneticSensorIcon } from '../../../Icons/Bits';
import { useDriveUnitPortRegistry } from '../../../../hooks/controls/useDriveUnitPortRegistry';

const MagneticProximitySwitchCard = (props: DeviceCardProps) => {
  const { t } = useTranslation();
  const { portControlValue, setPortControlValue, unsupportedRawValue } = useDriveUnitPortRegistry(props, 'sensor_port');

  return (
    <DeviceCardWrapper header={props.header} headerIcon={MagneticSensorIcon} initialOpen={props.initialOpen} onDelete={props.onDelete}>
      <DriveUnitPortControl
        {...props}
        parameterName="sensor_port"
        portControlValue={portControlValue}
        setPortControlValue={setPortControlValue}
        unsupportedRawValue={unsupportedRawValue}
        label={<Trans i18nKey="sensor.port">Sensor Port</Trans>}
        labelId="sensor-port-label"
        labelPopoverId="sensor-port-popover"
        labelPopover={t('sensor.port_info_tooltip')}
        selectId="sensor-port"
        selectLabelId="select-sensor-port-label"
      />
    </DeviceCardWrapper>
  );
};

export default MagneticProximitySwitchCard;
